import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { Course } from './models/course';

const courseService = {
  getItem(id: number): Promise<CommonResponse<Course>> {
    const url = `/course/${id}`;
    return axiosClient.get(url);
  },
  add(payload: Partial<Course>): Promise<CommonResponse<any>> {
    const url = '/courses';
    return axiosClient.post(url, payload);
  },
  update(id: number, payload: Partial<Course>): Promise<CommonResponse<any>> {
    const url = `/course/${id}`;
    return axiosClient.patch(url, payload);
  },
};

export default courseService;
